import { run } from "./fable/Main";
import worklets from "./worklets";
function start() {
  const context = new AudioContext();
  window["ctx"] = context;
  Promise.all(
    worklets.map((workletString) =>
      context.audioWorklet.addModule(workletString)
    )
  ).then(() => {
    run("main", context);
  });
}

start()